exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-size[data-v-53f4e2c6]{font-size:35px}.disp-cont[data-v-53f4e2c6]{display:contents}.column-xs[data-v-53f4e2c6]{-ms-flex-direction:column;flex-direction:column}.info-icon[data-v-53f4e2c6]{font-size:30px;color:#ff8100}\n", ""]);

// exports
